"use client";
import React, { useEffect, useState } from "react";
import HeroButton from "@/ui/HeroButton/HeroButton";
import { navLinks } from "@/data/constants";
import Link from "next/link";
import { useMobileNavActions } from "@/lib/useMobileNavActions/useMobileNavActions";
import { createPortal } from "react-dom";
import { useIframe } from "@/app/components/ui/AiChat/useIframe";
// import Image from "next/image";
const MobileNav: React.FC = () => {
  const { toggleOffcanvas } = useMobileNavActions();
  const [mounted, setMounted] = useState(false);

    const { handleClick } = useIframe();
  

  useEffect(() => {
    setMounted(true);
  }, []);

  const handelClickAISearch = ()=>{
    toggleOffcanvas(false)
    handleClick()

  }

  if (typeof document === "undefined" || !mounted) return null;
  return createPortal(
    
    <div className="hidden mobile-offcanvas backdrop-blur-md bg-hero-slate-970/80 fixed inset-0 z-[999] items-center px-5 xl:hidden animate-[zoomInModal_0.3s_ease]">
      <div className="h-full w-full flex justify-center items-center">
        <div
          onClick={() => toggleOffcanvas(false)}
          className="absolute top-12 right-7 cursor-pointer"
        >
          <img
            width={20}
            height={20}
            src="/imgs/close.svg"
            alt="close button"
          />
        </div>
        <div className="w-full ">
          <ul className=" flex flex-col items-center  gap-6">
            <li
              className={`h-full font-semibold px-4 cursor-pointer hover:text-hero-fuchsia-300 duration-200 transition-colors animate-[slideIn_0.4s]`}
              onClick={() => {
                handelClickAISearch();
              }}
            >
              <button >
                Ai Search
              </button>
            </li>
            {navLinks.map((item) => {
              // let a = index * 1.5 + 1;

              return (
                <li
                  className={`h-full font-semibold px-4 cursor-pointer hover:text-hero-fuchsia-300 duration-200 transition-colors animate-[slideIn_0.4s]`}
                  key={item.txt}
                  onClick={() => {
                    toggleOffcanvas(false);
                  }}
                >
                  {item.newTab ? (
                    <Link href={item.path} target="_blank">
                      {item.txt}
                    </Link>
                  ) : (
                    <Link href={item.path}>{item.txt}</Link>
                  )}
                </li>
              );
            })}
          </ul>
          <div className="mt-6 min-w-[102px] min-h-[37px] max-w-[192px] lg:max-w-[102px] mx-auto animate-[slideOut_0.3s]">
            <Link
              className="m-auto"
              href="https://wallet.hero.io"
              target="_blank"
            >
              <HeroButton>Wallet</HeroButton>
            </Link>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MobileNav;
